<template>
    <div class="column is-one-quarter left-side theme-style">
        <share-box v-bind:lot="lot"></share-box>
        <car-specs v-bind:lot="lot"></car-specs>
        <auc-info v-bind:lot="lot"></auc-info>
        <div class="">
            <table class="table">
                <tbody>
                <tr>
                    <th>Counter-offer:</th>
                    <td>
                        <div class="field">
                            <p class="control is-expanded" v-bind:class="{'clickEnq' : counter_offer.length}">
                                <input v-model="counter_offer" class="input" type="number" @keyup="changeText" placeholder="Counter-offer">
                            </p>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card" id="enquiry-form">
            <header class="card-header">
                <div class="card-header-title">
                    Free Quote / Inquiry
                </div>
                <div class="card-header-icon" aria-label="more options">
              <span class="icon has-text-danger">
                <i class="fas fa-yen" aria-hidden="true"></i>
              </span>
                </div>
            </header>
            <div class="card-content">
                <div v-if="alertMessage" class="has-text-success">{{ alertMessage }}</div>
                <div class="field is-horizontal">

                    <div class="field-label is-normal">
                        <label>Full Name</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control is-expanded">
                                <input v-model="full_name" class="input" type="text" placeholder="Full Name" readonly>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label>Email</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control is-expanded ">
                                <input v-model="email" class="input" type="email" placeholder="Email" readonly>

                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label>Country</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="select is-fullwidth">
                                <select v-model="country">
                                    <option value="">Select Country</option>
                                    <option v-for="country in countries">{{ country.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="errorMessage" class="has-text-danger">{{ errorMessage[0] }}</div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label>Phone<span class="has-text-danger">*</span></label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control is-expanded ">
                                <input required v-model="phone" class="input" type="number"
                                       placeholder="Phone Number">

                            </p>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <button class="button is-fullwidth is-danger enquiry" @click="sendEnquiry" :class="{ 'is-loading' : isLoading }">{{ btnText }}</button>
                </div>
            </div>
        </div>
        <div class="columns" v-if="isMobile">
            <div class="content column is-two-thirds main-image-column">
                <div class="equipment-section card">
                    <div class="card-header">Equipments</div>

                    <table class="table">
                        <tr>
                            <td>Carrier</td>
                            <td>Air Suspension</td>
                        </tr>
                        <tr>
                            <td>AM/FM Radio</td>
                            <td>Bumper Guard</td>
                        </tr>
                        <tr>
                            <td>CD Player</td>
                            <td>PBD</td>
                        </tr>
                        <tr>
                            <td class="active">Power Steering</td>
                            <td>Roof Rails</td>
                        </tr>
                        <tr>
                            <td>Sunproof</td>
                            <td>Aero</td>
                        </tr>
                        <tr>
                            <td class="active">Airbag</td>
                            <td>Half Leather Seats</td>
                        </tr>
                        <tr>
                            <td>Genuine Player</td>
                            <td class="active">Air Conditioner</td>
                        </tr>
                        <tr>
                            <td>Fabric Seats</td>
                            <td>Coil Spring</td>
                        </tr>
                        <tr>
                            <td class="active">ABS</td>
                            <td>Leather Seats</td>
                        </tr>
                        <tr>
                            <td>One Owner</td>
                            <td>Power Door Locks</td>
                        </tr>
                        <tr>
                            <td>LED</td>
                            <td>Service Record</td>
                        </tr>
                        <tr>
                            <td>Turbo</td>
                            <td>Air brake</td>
                        </tr>
                        <tr>
                            <td class="active">Alloy Wheels</td>
                            <td>Parallel Import</td>
                        </tr>
                        <tr>
                            <td>Power Seats</td>
                            <td class="active">Power Windows</td>
                        </tr>
                        <tr>
                            <td>CD Changer</td>
                            <td>DVD</td>
                        </tr>
                        <tr>
                            <td>Jack</td>
                            <td>Rear Spoiler</td>
                        </tr>
                        <tr>
                            <td class="active">Spare Tire</td>
                            <td colspan="2">TV/Navigation System</td>
                        </tr>
                    </table>

                </div>
            </div>
        </div>
        <div class="other-section" v-if="isMobile">
            <translate-box v-bind:lot="lot"></translate-box>
            <comments-box v-bind:lot="lot"></comments-box>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import CarSpecs from './CarSpecsStock'
    import AucInfo from './AucInfoStock'
    import ShareBox from '../Auctions/Lot/ShareBox.vue'
    import CommentsBox from '../Auctions/Lot/CommentsBox.vue'
    import TranslateBox from '../Auctions/Lot/Details/TranslationBox'

    export default {
        props: ['lot'],
        data() {
            return {
                full_name: this.lot.user.name,
                email: this.lot.user.email,
                country: this.lot.user_detail.country,
                phone: this.lot.user_detail.phone,
                counter_offer: '',
                countries: [],
                btnText: 'Enquiry',
            }
        },
        components: {
            carSpecs: CarSpecs,
            aucInfo: AucInfo,
            shareBox: ShareBox,
            commentsBox: CommentsBox,
            TranslateBox,
        },
        computed: {
            isMobile() {
                return document.documentElement.clientWidth < 450;
            },
            errorMessage() {
                return this.$store.getters.getStockCarErrorMessage
            },
            alertMessage() {
                return this.$store.getters.getStockCarAlertMessage
            },
            isLoading() {
                return this.$store.getters.getSearchResultsLoadingStatusStock
            }
        },
        methods: {

            sendEnquiry() {
                this.alertMessage = null;
                this.errorMessage = null;

                this.$store.dispatch('sendEnquiry', {
                    carObj: this.lot,
                    name: this.full_name,
                    email: this.email,
                    country: this.country,
                    phone: this.phone,
                    counter_offer: this.counter_offer
                })
                this.counter_offer = '';
            },
            changeText() {
                if(this.counter_offer){
                    this.btnText = 'Enquiry Counter-offer'
                }else{
                    this.btnText = 'Enquiry'
                }
            }
        },
        created() {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>
    .column {
        max-width: 100%;
    }

    .columns {
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        margin-bottom: 0;
    }

    .equipment-section .card-header {
        background: #192939;
        padding: 10px;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/LeftSideStock.vue